module.exports = __webpack_public_path__ + "static/media/EyeExamHold.5597772b.gif";